export const recordSessionTrafficSource = (search: string, doc = document): void => {
    if (search.match(/[?&]source=ft&?/)) {
        doc.cookie = 'source=ft;path=/reise/hotell';
    } else if (search.match(/[?&]utm_source=vg&?/)) {
        doc.cookie = 'source=vg;path=/reise/hotell';
    }
};

export const getSessionTrafficSource = (doc = document): string =>
    doc.cookie
        .split(';')
        .map((c) => c.trim().split('='))
        .filter(([key]) => key === 'source')
        .map(([, value]) => value)?.[0] || '';
